var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 4h-1.453c.073-.207.12-.433.12-.667a1.997 1.997 0 00-3.667-1.1l-.333.447-.334-.453A2.008 2.008 0 006 1.333c-1.107 0-2 .894-2 2 0 .234.046.46.12.667H2.665c-.74 0-1.326.593-1.326 1.333l-.007 7.334c0 .74.593 1.333 1.333 1.333h10.667c.74 0 1.333-.593 1.333-1.333V5.333c0-.74-.593-1.333-1.333-1.333zM9.999 2.667c.366 0 .666.3.666.666 0 .367-.3.667-.666.667a.669.669 0 01-.667-.667c0-.366.3-.666.667-.666zm-4 0c.366 0 .666.3.666.666C6.665 3.7 6.365 4 6 4a.669.669 0 01-.667-.667c0-.366.3-.666.667-.666zm7.333 10H2.665v-1.334h10.667v1.334zm0-3.334H2.665v-4h3.387L4.665 7.22l1.08.78L8 4.933 10.252 8l1.08-.78-1.387-1.887h3.387v4z",
    fill: "#9E9E9E"
  })));
}

export default SvgGift;